module.exports = __webpack_public_path__ + "img/drnykterstein.8811ccf3.png";